var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#DA1157",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.985 19.168a3.026 3.026 0 100-6.052 3.026 3.026 0 000 6.052zm0-10.005a6.98 6.98 0 11-5.003 11.843 6.955 6.955 0 001.977-4.864 6.954 6.954 0 00-1.977-4.864 6.957 6.957 0 015.003-2.115zM10.98 19.168a3.026 3.026 0 100-6.052 3.026 3.026 0 000 6.052zm5.003-7.89a6.955 6.955 0 00-1.976 4.864c0 1.892.754 3.607 1.976 4.864a6.98 6.98 0 110-9.728zm-1.977 4.865c0 1.892.754 3.607 1.977 4.864a6.954 6.954 0 001.976-4.864 6.954 6.954 0 00-1.976-4.864 6.954 6.954 0 00-1.977 4.864z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMft);
export default __webpack_public_path__ + "static/media/mft.e48b8d36df573745a060768b23abdb68.svg";
export { ForwardRef as ReactComponent };